'use client';

import React, { useCallback, useEffect } from 'react';
import { useRouter, useSearchParams } from 'next/navigation';
import { SsoType } from '@diritto/common/account/constants/sso.constant';
import { Color } from '@diritto/common/style/color';
import { AccountApi } from 'api/ApiHelper';
import { LoginButton } from 'app-components/accounts/LoginButton';
import { LoginLayout } from 'app-components/common/layout/LoginLayout';
import { ArrowIcon } from 'icons/ArrowIcon';
import { Link } from 'ui-components/common/Link';
import { configure } from 'utils/configure';
import { showAlertModal } from 'utils/modal';
import { normalizeReturnUrl } from 'utils/normalizer';

export const SignInPage = () => {
  const router = useRouter();
  const searchParams = useSearchParams();
  const isNotProduction = !configure.isProd;
  const normalizedReturnUrl = normalizeReturnUrl(searchParams?.get('returnUrl') as string | undefined);
  const isDormant = searchParams?.get('isDormant') && searchParams?.get('isDormant') === 'true';
  const dormantToken = String(searchParams?.get('dormantToken'));

  const handleRevertDormant = useCallback(async () => {
    await AccountApi.revertDormant({ token: dormantToken });
    router.replace(`/accounts/sign-in/finished`);
  }, [dormantToken, router]);

  useEffect(() => {
    if (isDormant) {
      showAlertModal(
        {
          title: '현재 로그인한 계정은 휴면 상태예요',
          description:
            '디리토에 1년 이상 로그인하지 않아 휴면 상태로 전환되었어요.\n\n' +
            '휴면을 해제하시면 기존 계정 그대로 디리토를 이용하실수 있어요.',
        },
        { cancelText: '닫기', confirmText: '휴면 해제하기', onConfirm: handleRevertDormant },
      );
    }
  }, [handleRevertDormant, isDormant]);

  return (
    <LoginLayout title="로그인 및 회원가입" description="디리토에 오신 것을 환영해요!" header>
      <div className="flex flex-col space-y-2.5">
        <LoginButton ssoType={SsoType.Kakao} normalizedReturnUrl={normalizedReturnUrl} />
        <LoginButton ssoType={SsoType.Naver} normalizedReturnUrl={normalizedReturnUrl} />
        <LoginButton ssoType={SsoType.Apple} normalizedReturnUrl={normalizedReturnUrl} />
        <LoginButton ssoType={SsoType.Google} normalizedReturnUrl={normalizedReturnUrl} />
        {isNotProduction && <LoginButton ssoType={SsoType.Email} normalizedReturnUrl={normalizedReturnUrl} />}
      </div>
      <div className="pt-6 flex justify-center items-center">
        <Link
          href="/accounts/partners/sign-in"
          className="flex flex-row justify-center items-center text-gray-500 text-xs font-bold">
          파트너 계정 로그인 <ArrowIcon direction="right" color={Color.Gray500} className="size-[20px]" />
        </Link>
      </div>
    </LoginLayout>
  );
};
